// Injected into the same-origin Readme OSS iframe to match the Siemens brand theme.
export const IFRAME_THEME_CSS = `
  *, *::before, *::after {
    font-family: "Siemens Sans", "Siemens Sans Global", Arial, sans-serif !important;
    box-sizing: border-box;
  }
  html, body {
    background-color: #23233c !important;
    color: #ffffff !important;
    margin: 1rem !important;
    line-height: 1.5 !important;
    overflow-x: hidden !important;
  }
  h1, h2, h3, h4, h5, h6 {
    color: #ffffff !important;
    font-weight: 700 !important;
    margin-block: 0.75rem !important;
  }
  h1 { font-size: 1.25rem !important; }
  h2 { font-size: 1.1rem !important; }
  h3 { font-size: 1rem !important; }
  p { color: #ffffff !important; font-weight: normal !important; }
  a, a:link, a:visited, .top {
    color: #1ab38a !important;
    text-decoration: none !important;
  }
  a:hover, .top:hover {
    color: #00ffb9 !important;
    text-decoration: underline !important;
  }
  .inset {
    background-color: #343448 !important;
    border-top: 1px solid #4a4a60 !important;
    border-right: 1px solid #4a4a60 !important;
    border-radius: 4px !important;
    margin-block: 0.5rem !important;
  }
  .inset p { white-space: pre-wrap !important; color: #ffffff !important; word-break: break-word !important; overflow-wrap: break-word !important; }
  .inset .groupId { color: #ffffff !important; font-size: 12px !important; }
  table { border-collapse: collapse !important; width: 100% !important; max-width: 100% !important; table-layout: fixed !important; margin-block: 1rem !important; }
  table, th, td { border: 1px solid #4a4a60 !important; }
  th {
    height: 40px !important;
    background-color: #343448 !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    padding: 0.4rem 0.75rem !important;
  }
  td { padding: 0.4rem 0.75rem !important; color: #ffffff !important; word-break: break-word !important; overflow-wrap: break-word !important; }
  tr:hover td { background-color: #343448 !important; }
  .error, .error td { background-color: #7a2020 !important; color: #ffffff !important; }
  ::-webkit-scrollbar { width: 3px; height: 3px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background-color: #00ffb9; border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background-color: #1ab38a; }
  * { scrollbar-width: thin; scrollbar-color: #00ffb9 transparent; }
`;
